import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import "../css/ContactUsPage.css";

const ContactUsPage = () => {
  return (
    <>
      <Header />

      {/* Map Section */}
      <section className="contact-map-section">
        <div className="absolute top-0 left-0 w-full h-full pointer-events-none z-10" />
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3960.442786758003!2d79.85514401419474!3d6.956980319903581!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae258e94e408311%3A0xf89ad930651623ac!2sColombo+Dockyard+PLC!5e0!3m2!1sen!2slk!4v1471316666743"
          width="100%"
          height="460"
          frameBorder="0"
          style={{ border: 0 }}
          allowFullScreen
          title="Colombo Dockyard Map"
        />
      </section>

      {/* Main Content */}
      <section className="contentwrapper contact-page">
        <div className="content">
          {/* Breadcrumbs */}
          <div className="contact-breadcrumb">
            <a href="/">Home</a> &gt; <span>Contact Us</span>
          </div>

          <h1>CONTACT US</h1>

          {/* General Inquiry Section */}
          <h2
            style={{
              textAlign: "center",
              fontWeight: "bold",
              textTransform: "uppercase",
              fontFamily: "proxima_nova_bold, Arial, sans-serif",
            }}
          >
            General Inquiry
          </h2>

          {/* Full-width Form Row (General Inquiry) */}
          <div
            className="vc_row vc_row-flex vc_row-full-width vc_row-no-padding vc_custom_0300 clearfix"
            style={{
              backgroundImage:
                "url('/wp-content/uploads/2016/01/DSC_0300.jpg')",
            }}
          >
            {/* Left Col: Contact Info */}
            <div className="vc_col-sm-6 custom-pad-inquiry-left">
              <div className="white-box">
                <p>
                  <strong>
                    Colombo Dockyard PLC
                    <br />
                    P.O. Box 906
                    <br />
                    Port of Colombo
                    <br />
                    Colombo 15
                    <br />
                    Sri Lanka
                  </strong>
                </p>
                <p>
                  <strong>
                    Call us at: <a href="tel:+94112429000">+94 11 242 9000</a>
                  </strong>
                  <br />
                  <strong>
                    Fax us at: <a href="fax:+94112446441">+94 11 244 6441</a> |{" "}
                    <a href="fax:+94112329479">+94 11 232 9479</a>
                  </strong>
                  <br />
                  <strong>Email us at: coldock@cdl.lk</strong>
                </p>
                <p>
                  <span
                    className="dwnload-icon-blue"
                    style={{
                      position: "relative",
                      display: "inline-block",
                      paddingRight: "25px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <a
                      href="/wp-content/uploads/2020/02/Guide-Document-Visit-CDPLC-2.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Download Guide to Visit Colombo Dockyard PLC facility
                    </a>
                    <span
                      style={{
                        position: "absolute",
                        right: 0,
                        top: "4px",
                        width: "14px",
                        height: "14px",
                        backgroundRepeat: "no-repeat",
                        backgroundImage:
                          "url('/wp-content/themes/cdl/images/download-icon-blue.png')",
                      }}
                    ></span>
                  </span>
                </p>
              </div>
            </div>

            {/* Right Col: Form */}
            <div className="vc_col-sm-6 custom-pad-inquiry-right">
              <div className="contact-form inquery-form">
                <form id="formhoundContactForm">
                  <div className="fieldBlock float-l">
                    Name <span className="red-icon">*</span>
                    <input
                      className="form-control"
                      type="text"
                      name="fullname"
                      required
                    />
                  </div>
                  <div className="fieldBlock float-l">
                    Email <span className="red-icon">*</span>
                    <input
                      className="form-control"
                      type="email"
                      name="email"
                      required
                    />
                  </div>
                  <div className="fieldBlock float-l">
                    Telephone <span className="red-icon">*</span>
                    <input
                      className="form-control"
                      type="text"
                      name="telephone_no"
                    />
                  </div>
                  <div className="fieldBlock float-l">
                    Inquiry <span className="red-icon">*</span>
                    <select className="form-control" name="inquiry">
                      <option value="Ship Repair Inquiry|darshanc@cdl.lk">
                        Ship Repair Inquiry | darshanc@cdl.lk
                      </option>
                      <option value="Ship Building Inquiry|princel@cdl.lk">
                        Ship Building Inquiry | princel@cdl.lk
                      </option>
                      <option value="General Inquiry|coldock@cdl.lk">
                        General Inquiry | coldock@cdl.lk
                      </option>
                      <option value="Vendor Inquiry|vajirar@cdl.lk">
                        Vendor Inquiry | vajirar@cdl.lk
                      </option>
                    </select>
                  </div>
                  <div className="fieldBlock txt-msg float-l">
                    Question <span className="red-icon">*</span>
                    <div className="textarea-msg">
                      <textarea
                        className="form-control"
                        name="question"
                        required
                      ></textarea>
                    </div>
                  </div>
                  <div className="fieldBlock float-l">
                    <input type="submit" id="submit-btn" value="SUBMIT" />
                  </div>
                </form>
              </div>
            </div>
          </div>

          {/* Vendor Heading */}
          <div className="vendor-heading-bar">
            <h2
              style={{
                margin: 0,
                fontWeight: "bold",
                textTransform: "uppercase",
                fontFamily: "proxima_nova_bold, Arial, sans-serif",
              }}
            >
              For vendor registration please contact following
            </h2>
          </div>

          {/* Vendor Registration Section (Full Width) */}
          <div
            className="vc_row vc_row-flex vc_row-full-width vc_row-no-padding vc_custom_hengineering clearfix"
            style={{
              backgroundImage:
                "url('/wp-content/uploads/2016/01/hengineering.jpg')",
            }}
          >
            {/* Left Col: Form 2 */}
            <div className="vc_col-sm-6 custom-pad-vendor-left">
              <div className="contact-form">
                <form id="formhoundContactForm2">
                  <div className="fieldBlock float-l">
                    Name <span className="red-icon">*</span>
                    <input
                      className="form-control"
                      type="text"
                      name="fullname"
                      required
                    />
                  </div>
                  <div className="fieldBlock float-l">
                    Email <span className="red-icon">*</span>
                    <input
                      className="form-control"
                      type="email"
                      name="email"
                      required
                    />
                  </div>
                  <div className="fieldBlock float-l">
                    Telephone <span className="red-icon">*</span>
                    <input
                      className="form-control"
                      type="text"
                      name="telephone_no"
                    />
                  </div>
                  <div className="fieldBlock float-l">
                    Inquiry <span className="red-icon">*</span>
                    <select className="form-control" name="inquiry">
                      <option value="Vendor Registration|vajirar@cdl.lk">
                        Vendor Registration|vajirar@cdl.lk
                      </option>
                    </select>
                  </div>
                  <div className="fieldBlock txt-msg float-l">
                    Question <span className="red-icon">*</span>
                    <div className="textarea-msg">
                      <textarea
                        className="form-control"
                        name="question"
                        required
                      ></textarea>
                    </div>
                  </div>
                  <div className="fieldBlock float-l">
                    <input type="submit" id="submit-btn" value="SUBMIT" />
                  </div>
                  <div style={{ display: "none" }}>
                    <a
                      href="/wp-content/uploads/2025/03/CDL_DigitalBusinessCard.html"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View Contact Details
                    </a>
                  </div>
                </form>
              </div>
            </div>

            {/* Right Col: Direct Contacts */}
            <div className="vc_col-sm-6 custom-pad-vendor-right contact-cards pt-[20px] md:pt-[60px]">
              <div className="white-box">
                <h2>
                  YOUR DIRECT CONTACT FOR <span>SHIP REPAIRS</span>:
                </h2>
                <p>
                  <strong>Asst. General Manager (Ship Repair Business):</strong>
                  <br />
                  Darshana Chandrasekera
                  <br />
                  <strong>Direct Number:</strong>{" "}
                  <a href="tel:+94112429016">+94 11 242 9016</a>
                  <br />
                  <strong>Mobile Phone:</strong>{" "}
                  <a href="tel:+94777390108">+94 77 739 0108</a>
                  <br />
                  <strong>E-mail:</strong> darshanc@cdl.lk
                </p>
                <p>
                  <strong>Marketing & Estimating:</strong>
                  <br />
                  <strong>E-mail:</strong> colombodock@cdl.lk
                </p>
              </div>

              <div className="white-box">
                <h2>
                  YOUR DIRECT CONTACT FOR <span>SHIPBUILDING</span> :
                </h2>
                <p>
                  <strong>Head of Marketing:</strong>
                  <br />
                  Prince Lye
                  <br />
                  <strong>Direct Number:</strong>{" "}
                  <a href="tel:+94112429067">+94 11 242 9067</a>
                  <br />
                  <strong>Mobile Phone:</strong>{" "}
                  <a href="tel:+94777730220">+94 77 773 0220</a>
                  <br />
                  <strong>E-mail:</strong> princel@cdl.lk
                </p>
              </div>

              <div className="white-box">
                <h2>
                  YOUR DIRECT CONTACT FOR <span>HEAVY ENGINEERING</span>:
                </h2>
                <p>
                  <strong>General Manager:</strong>
                  <br />
                  S.D. GILBERT (
                  <a
                    href="https://www.dges.lk/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    www.dges.lk
                  </a>
                  )<br />
                  <strong>Direct Line:</strong>{" "}
                  <a href="tel:+94112110512">+ 94 112 110 512</a>
                  <br />
                  <strong>Mobile Phone:</strong>{" "}
                  <a href="tel:+94777315019">+ 94 77 731 5019</a>
                  <br />
                  <strong>E-mail:</strong> sdgilbert@dges.lk
                </p>
              </div>
            </div>
          </div>

          {/* Third Row: Marine Hardware & Emergency Numbers */}
          <div
            className="bottom-section-row"
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "40px",
            }}
          >
            <div style={{ flex: 1, minWidth: "300px" }}>
              <h2>YOUR DIRECT CONTACT FOR MARINE AND INDUSTRIAL HARDWARE:</h2>
              <p style={{ lineHeight: 1.6 }}>
                <strong>Assistant General Manager Sales:</strong>
                <br />
                F. Felix
                <br />
                <strong>General Lines:</strong>{" "}
                <a href="tel:+94112424708">+94 11 242 4708</a> |{" "}
                <a href="tel:+94112424709">+94 11 242 4709</a>
                <br />
                <strong>Fax:</strong>{" "}
                <a href="fax:+94114714151">+94 11 471 4151</a>
                <br />
                <strong>E-mail:</strong> marine_hardware@dges.lk
              </p>
            </div>

            <div style={{ flex: 1, minWidth: "300px" }}>
              <h2>EMERGENCY NUMBERS :</h2>
              <p style={{ lineHeight: 1.6 }}>
                <strong>Fire: </strong> <a href="tel:2444">2444</a>
                <br />
                <strong>Fire (Supervisors): </strong>{" "}
                <a href="tel:1044">1044</a>
                <br />
                <strong>Ambulance: </strong> <a href="tel:2222">2222</a>
                <br />
                <strong>Security: </strong> <a href="tel:1222">1222</a>
                <br />
                <strong>Safety Office: </strong> <a href="tel:1088">1088</a>
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <BackToTop />
    </>
  );
};

export default ContactUsPage;
